import AddIcon from "@mui/icons-material/Add";
import { Box, Button } from "@mui/material";
import useDisclosure from "../../../../../hooks/use-disclosure";
import Flex from "../../../../Flex";
import LabeledSwitch from "../../../../LabeledSwitch";
import CustomTitle from "../../../CustomTitle";
import EducationMaterialFilter, {
  EducationMaterialFilterInitialValuesType,
} from "./EducationMaterialFilter";
import UpsertEducationDrawer from "./UpsertEducationDrawer";
import SearchInput from "../../../../SearchInput";

const EducationMaterialTopBar = ({
  onApply,
  filters,
  instantSearchVal,
  setSearch,
  archive,
  setArchive,
  setFilter,
}: {
  onApply: (v: any) => void;
  filters: EducationMaterialFilterInitialValuesType;
  instantSearchVal: string;
  setSearch: (v: string) => void;
  archive: boolean;
  setArchive: (v: boolean) => void;
  setFilter: (v: EducationMaterialFilterInitialValuesType) => void;
}) => {
  const disclosureHost = useDisclosure();

  return (
    <Box display="flex" alignItems="center" justifyContent="space-between">
      <CustomTitle>Education Materials</CustomTitle>

      <Flex gap={2} alignItems="center" justifyContent="center">
        <LabeledSwitch
          label="Show Archived Materials"
          checked={archive}
          onChange={(e) => setArchive(e.target.checked)}
        />

        <Box width="280px">
          <SearchInput
            searchKey={instantSearchVal}
            onSearch={(val) => setSearch(val)}
            placeholder={`Search with title,condition`}
          />
        </Box>

        <EducationMaterialFilter
          onApply={onApply}
          filters={filters}
          setFilter={setFilter}
        />
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          color="primary"
          onClick={() => disclosureHost.open()}
        >
          Upload New Document
        </Button>
      </Flex>

      {disclosureHost.opened && (
        <UpsertEducationDrawer disclosureHost={disclosureHost} />
      )}
    </Box>
  );
};

export default EducationMaterialTopBar;
